import { accidentResponsibilityHandler } from "./accidentResponsibility";
import { bodyShopsByPostCodeHandler } from "./bodyShopsByPostCode";
import { citiesByProvinceHandler } from "./citiesByProvince";
import { clientConfigHandlers } from "./clientConfig";
import { estimateHandlers } from "./estimate";
import { localeHandlers } from "./locale";
import { offerHandlers } from "./offer";
import { sessionHandlers } from "./session";
import { uploadHandlers } from "./upload";
import { versionHandlers } from "./version";

export const allHandlers = [
  ...estimateHandlers,
  ...sessionHandlers,
  ...uploadHandlers,
  ...clientConfigHandlers,
  ...versionHandlers,
  ...localeHandlers,
  ...offerHandlers,
  ...citiesByProvinceHandler,
  ...accidentResponsibilityHandler,
  ...bodyShopsByPostCodeHandler,
];
